"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_array_like_1 = require("./is-array-like");
function head(o) {
    if (is_array_like_1.default(o)) {
        return o[0];
    }
    return undefined;
}
exports.default = head;
//# sourceMappingURL=head.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/head.js
// module id = 1107
// module chunks = 37